import { AxiosResponse } from 'axios';
import { useFormik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { ModelOfBrand } from '../../database';
import api from '../../services/api';
import * as Yup from 'yup';

export const useListBrandsController = () => {
	const [brandsData, setBrandsData] = useState<ModelOfBrand[]>([]);
	const [selectedBrand, setSelectedBrand] = useState<ModelOfBrand>();
	const [loading, setLoading] = useState(true);
	const [editDialog, setEditDialog] = useState(false);
	const [deleteDialog, setDeleteDialog] = useState(false);

	const { userAgencyId } = useAuth();

	const toast: any = useRef();

	const validationSchema = Yup.object().shape({
		DESCRICAO: Yup.string().required('* Campo obrigatório'),
	});

	const getBrands = () => {
		api.get(`brands/${userAgencyId}`)
			.then(response => {
				const data = response.data;

				setBrandsData(data);
				setLoading(false);
			})
			.catch((response: AxiosResponse) => {
				console.log('erro: ', response.status);
				setLoading(false);
			});
	};

	const removeBrand = (brand: ModelOfBrand) => {
		setLoading(true);
		api.delete(`brands/${brand.ID}`)
			.then(() => {
				getBrands();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Remoção realizada',
					detail: 'A marca foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getBrands();
				setDeleteDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Remoção não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const editBrand = (brand: ModelOfBrand) => {
		setLoading(true);

		const editedBrand: ModelOfBrand = {
			...brand,
			ORGAO: userAgencyId,
		};

		api.put(`brands/${selectedBrand?.ID}`, editedBrand)
			.then(() => {
				getBrands();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Edição realizada',
					detail: 'A marca foi editada com sucesso!',
					life: 5000,
				});
			})
			.catch(err => {
				getBrands();
				setEditDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Edição não realizado',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	useEffect(() => {
		getBrands();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userAgencyId]);

	const openDeleteDialog = (brand: ModelOfBrand) => {
		setDeleteDialog(true);
		setSelectedBrand(brand);
	};

	const closeDeleteDialog = () => {
		setDeleteDialog(false);
	};

	const openEditDialog = (brand: ModelOfBrand) => {
		setEditDialog(true);
		setSelectedBrand(brand);
	};

	const closeEditDialog = () => {
		setEditDialog(false);
	};

	const formik = useFormik<ModelOfBrand>({
		initialValues: {
			ORGAO: '',
			DESCRICAO: '',
		},
		onSubmit: values => editBrand(values),
		validationSchema,
	});

	return {
		getBrandListController: {
			formik,
			brandsData,
			selectedBrand,
			loading,
			deleteDialog,
			editDialog,
			toast,
		},
		handleBrandListController: {
			removeBrand,
			editBrand,
			openDeleteDialog,
			closeDeleteDialog,
			openEditDialog,
			closeEditDialog,
			getBrands,
		},
	};
};
